import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import styles from "./EditWarehouseDetail.module.scss";
import { useNavigate } from "react-router-dom";
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton";

const EditWarehouseDetail = () => {
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Form submitted");
  };

  return (
    <div className={styles["bg-gray"]}>
      <div className="bg-white shadow mt-3 m-3 p-3">
        <div className="fw-semibold fs-4 text-center mb-3">
          Add Partner Warehouse
        </div>

        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="partnerName">Partner Name</Label>
                <Input id="partnerName" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="warehouseLocation">Warehouse location</Label>
                <Input id="warehouseLocation" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="capacity">Capacity</Label>
                <Input id="capacity" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="contactDetails">Contact Details</Label>
                <Input id="contactDetails" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="status">Status</Label>
                <Input id="status" placeholder="" type="text" />
              </FormGroup>
            </Col>
          </Row>

          <div className="d-flex gap-2 justify-content-end">
            <DynamicButton theme="blue" outline onClick={() => navigate(-1)}>
              Cancel
            </DynamicButton>
            <DynamicButton>Save</DynamicButton>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default EditWarehouseDetail;